import { useState, type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { hasPlgSession } from "plg/auth/plgTokenStore";
import { HIRE_ROUTES } from "plg/routes";
import useRecheckOnRestore from "plg/shell/useRecheckOnRestore";

/**
 * The sign-up pages are for signed-out visitors only: a signed-in PLG customer who lands on one
 * (typed URL, or Back from /hire) is replaced to /hire/home, so Back never returns to sign-up.
 * Decided once on arrival: the welcome page starts the session itself and then moves on. A page
 * restored from the back/forward cache is checked again.
 */
function PlgGuestRoute({ children }: { children: ReactNode }) {
  const [signedIn] = useState(hasPlgSession);
  useRecheckOnRestore(hasPlgSession, HIRE_ROUTES.home);
  if (signedIn) return <Navigate to={HIRE_ROUTES.home} replace />;
  return <>{children}</>;
}

export default PlgGuestRoute;
